import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback } from 'react';

export const OutOfOfficeList = ({ userObj: user }) => {
  const augRowsReq = useCallback(
    (rowsReq) => {
      if (!user) return;
      rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('username', user.username));
    },
    [user],
  );

  return <EntityList module="skdr" entity="APPR_ROUTE_USER" augRowsReq={augRowsReq} />;
};
